import { useI18n } from '@hooks/useI18n';
import {
  CustomerAgreementSigningOverview,
  ManualIdentityUploadSummary,
} from '../types';
import { CustomerAgreementStatusCard } from './CustomerAgreementStatusCard';
import { ManualIdentityDocumentStatusCard } from './ManualIdentityDocumentStatusCard';
import { StatusCardGridContainer, StatusCardGridWrapper } from './Styled';

interface IApplicationDocumentsStatusCards {
  customerAgreementSigningOverview: CustomerAgreementSigningOverview;
  manualIdentityUploadSummary: ManualIdentityUploadSummary;
}

export const ApplicationDocumentsStatusCards = ({
  customerAgreementSigningOverview,
  manualIdentityUploadSummary,
}: IApplicationDocumentsStatusCards) => {
  const { translate } = useI18n();

  return (
    <StatusCardGridWrapper>
      <StatusCardGridContainer>
        <ManualIdentityDocumentStatusCard
          manualIdentityUploadSummary={manualIdentityUploadSummary}
          translate={translate}
        />
        <CustomerAgreementStatusCard
          customerAgreementSigningOverview={customerAgreementSigningOverview}
          translate={translate}
        />
      </StatusCardGridContainer>
    </StatusCardGridWrapper>
  );
};
